<template>
<b-card header="Edit Lock Group">
  <b-form v-on:submit.prevent>
    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Name</b-input-group-text>
        </b-input-group-prepend>
        <input type="text" v-model="formData.name" placeholder="name" @keyup.enter="submitData($event.target)" class="form-control"/>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-user"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <div class="form-group form-actions">
      <b-button @click="submitData($event.target)" type="button" size="sm" variant="primary">Save</b-button>
    </div>
  </b-form>
</b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockgroups/add'
const API_EDIT = BASE + '/api/lockgroups/edit'
//const API_WITH_ID = BASE + '/api/lockgroups/detail'
const API_LIST = BASE + '/api/lockgroups/list'

// async function getData (id) {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token'),
//     lockGroupId: id
//   }
//   let res = await postdata(API_WITH_ID, parameters)
//   return res.lockGroup
// }

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  }).then(res => res.json())
}

async function getLockgroups () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId')
  }
  let res = await postdata(API_LIST, parameters)
  return res.lockGroups
}

export default {
  name: 'lock-group-edit-form',
  data () {
    return {
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        name: null,
        groupId: '',
        locationId: null,
        lockGroupId: this.lockGroupId
      }
    }
  },
  props: ['locationName', 'locationDescription', 'lockGroupId', 'modalEditId'],
  mounted () {
    let id = this.lockGroupId
    if (id > 0) {

      let localLocationlist = localStorage.getItem('localLocationsList')
      let locationId = localStorage.getItem('locationId')

      if(localLocationlist) {
        
        localLocationlist = JSON.parse(localLocationlist)
        let indexLocation = localLocationlist.findIndex(location => location.id == locationId)
        this.$data.formData.name = localLocationlist[indexLocation].lockgroups[localLocationlist[indexLocation].lockgroups.findIndex(lg => lg.id == id)].name
      }
      

    }
  },
  methods: {
    submitData (button) {
      let id = this.$route.params.id
      let lockGroupId = this.lockGroupId
      if (id || lockGroupId) {
    
        this.formData.groupId = id ? id : lockGroupId
        postdata(API_EDIT, this.formData)
          .then(data => {
             
            let localLocationList = localStorage.getItem('localLocationsList')
            let locationId = localStorage.getItem('locationId')

            if(localLocationList) {
              
              localLocationList = JSON.parse(localLocationList)
              let locIndex = localLocationList.findIndex(loc => loc.id == locationId);
              let oldLockgroup = localLocationList[locIndex].lockgroups[localLocationList[locIndex].lockgroups.findIndex(lg => lg.id == data.lockgroup.id)]
              let oldLocksCount = oldLockgroup.locksCount
              let newLockgroup = data.lockgroup
              newLockgroup.locksCount = oldLocksCount
              localLocationList[locIndex].lockgroups.splice(localLocationList[locIndex].lockgroups.findIndex(lg => lg.id == data.lockgroup.id),1,newLockgroup);
              localStorage.setItem('localLocationsList', JSON.stringify(localLocationList))
              

              let updateLockgroups = localLocationList[locIndex].lockgroups
              this.$root.$emit('lockGroups', updateLockgroups)
            }

            if(data.status.errCode == 200) {

            let localLocksList = localStorage.getItem('localLocksList')
            localLocksList = JSON.parse(localLocksList)

            for(let k in localLocksList) {
              let locks = localLocksList[k]
              for(let l in locks.lockGroups) {
                let lg = locks.lockGroups[l]
                if(lg.lockGroupId == lockGroupId) {
                  lg.mappedLockGroup = data.lockgroup
                }
              }
            }
            localStorage.setItem('localLocksList', JSON.stringify(localLocksList))

            }
          
            let modalId = 'modaledit' + data.lockgroup.id
            this.$root.$emit('bv::hide::modal', modalId)
            
          })
          .catch(error => {
            console.error(error)
          })
      } else {
        postdata(API, this.formData)
          .then(data => {
            getLockgroups().then(dataList => {
              this.$root.$emit('lockGroups', dataList)
              this.$root.$emit('bv::hide::modal', this.modalEditId, button)
            })
            console.log(data)
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockGroupEditForm.vue